import React, { useState, Component } from 'react';
import { Tag, Input, Tooltip, Icon } from 'antd';


const CopyThat = (props) => {
    const _id = new Date() * parseInt(Math.random() * 100000);
    const [copied, setCopied] = useState(false);
    return (
        <span className={`${props.className}`}>
            <Tooltip title={copied ? "Copied" : "Copy"}>
                {renderDefault(props, _id, copied, setCopied)}
                {renderCustom(props, _id, setCopied)}
            </Tooltip>
            <Input style={{ position: 'fixed', top: -5000 }} value={props.copyText} id={_id} autoComplete='off'/>
        </span>
    )
}

const renderCustom = (props, _id, setCopied) => {
    if (!props.render) { return null }
    const Component = React.cloneElement(props.render, {
        onClick: () => copy(_id, setCopied)
    });
    return Component;
}

const renderDefault = (props, _id, copied, setCopied) => {
    if (props.render) { return null }
    return (
        props.onlyIcon ? (
            <Icon type={copied ? "check" : "copy"} style={{ color: props.iconColor }} className={`c-pointer`} onClick={() => { copy(_id, setCopied) }} />
        ) : (
                <Tag className={`c-pointer`} onClick={() => { copy(_id, setCopied) }}>
                    <Icon type={copied ? "check" : "copy"} style={{ color: props.iconColor }} className="mr-1" />
                    <span>{props.buttonText}</span>
                </Tag>
            )
    )
}

const copy = (id, setCopied) => {
    const element = document.getElementById(id);
    element.select();
    const result = document.execCommand('copy');
    if (result) { setCopied(true) }
    setTimeout(() => { setCopied(false) }, 2000);
}

CopyThat.defaultProps = {
    buttonText: "Copy",
    copyText: "",
    className: "",
    style: {},
    iconColor: "#1890ff",
    render: undefined,
    onlyIcon: false,
}

export { CopyThat }